import type { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

type ButtonTheme = 'primary' | 'secondary' | 'outline' | 'gray';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: ButtonTheme;
}

export function Button({
  children,
  theme = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const themeClass = styles[theme] || styles.primary;

  return (
    <button
      className={`${styles.button} ${themeClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
